import { MsgExecuteContract } from '@goblinhunt/cosmes/client'
import { Coin } from '@goblinhunt/cosmes/registry'
import { StakeResponse } from 'models/staking-liquidity/StakeResponse'
import { StakingInfoResponse } from 'models/staking-liquidity/StakingInfoResponse'
import { useWallet } from 'provider/WalletProvider'
import { useState } from 'react'
import { LIQUIDITY_STAKING_ADDRESS } from 'utils/Constants'
import { toDenom } from 'utils/Helpers'
import { showLoadingToast, showTxToast } from 'utils/Toasts'

type Props = {
    balance?: Coin,
    stakingInfo?: StakingInfoResponse,
    stakeInfo?: StakeResponse,
    onRefresh: () => void
}

export function ManageAssetCard({ balance, stakingInfo, onRefresh, stakeInfo }: Props) {
    const [amount, setAmount] = useState("0")
    const [process, setProcess] = useState<string>()
    const { address, post } = useWallet()

    const isValid = (_process?: string) => {
        _process = _process ?? process;

        if (_process != "withdraw") {
            let amountNum = Number(amount)
            if (isNaN(amountNum) || amountNum <= 0) return "Amount must be more than 0, use . (period) as decimal separator"
            if (_process == "stake" && toDenom(amountNum, 6) > Number(balance?.amount ?? "0")) return "Your balance is not enough"
            if (_process == "unstake" && toDenom(amountNum, 6) > Number(stakeInfo?.amount ?? "0")) return "Cannot unstake more than your staked assets"
        }

    }

    const stake = async () => {
        setProcess("stake")
        if (isValid("stake")) return;

        const stakeMsg = {
            stake: {}
        }

        const stakeAmount = toDenom(Number(amount), 6);
        const executeMsg = new MsgExecuteContract({
            sender: address!,
            contract: LIQUIDITY_STAKING_ADDRESS!,
            msg: stakeMsg,
            funds: [
                {
                    amount: stakeAmount.toString(),
                    denom: "uluna"
                }
            ]
        })
        const msgs = [executeMsg]

        const result = await showLoadingToast("Signing transaction", () => post({
            msgs
        }, stakeAmount * 0.005))

        await showTxToast(result)
        onRefresh()
    }

    const unstake = async () => {
        setProcess("unstake")
        if (isValid("unstake")) return;

        const unstakeAmount = toDenom(Number(amount), 6);
        const unstakeMsg = {
            unstake: {
                amount: unstakeAmount.toString()
            }
        }

        const executeMsg = new MsgExecuteContract({
            sender: address!,
            contract: LIQUIDITY_STAKING_ADDRESS!,
            msg: unstakeMsg,
            funds: []
        })
        const msgs = [executeMsg]

        const result = await showLoadingToast("Signing transaction", () => post({
            msgs
        }))

        await showTxToast(result)
        onRefresh()
    }

    const withdraw = async () => {
        setProcess("withdraw")
        if (isValid("withdraw")) return;

        const withdrawMsg = {
            withdraw: {}
        }

        const executeMsg = new MsgExecuteContract({
            sender: address!,
            contract: LIQUIDITY_STAKING_ADDRESS!,
            msg: withdrawMsg,
            funds: []
        })
        const msgs = [executeMsg]

        const result = await showLoadingToast("Signing transaction", () => post({
            msgs
        }))

        await showTxToast(result)
        onRefresh()
    }

    return <div className="card">
        <div className="card h-100">
            <div className="card-header d-flex align-items-center justify-content-between pb-0">
                <div className="card-title mb-0">
                    <h5 className="">Manage Asset</h5>
                </div>
            </div>
            <div className="card-body">
                <div className="mb-3">
                    <label htmlFor="asset-amount" className="form-label">Amount</label>
                    <div className="input-group">
                        <input
                            onChange={({ target }) => setAmount(target.value)}
                            value={amount}
                            type="number"
                            className="form-control"
                            id="asset-amount"
                            placeholder="Enter amount"
                        />
                        <span className="input-group-text">LUNC</span>
                    </div>
                </div>
                {
                    (process && isValid()) && <div className="alert alert-danger" role="alert">{isValid()}</div>
                }
                {
                    (address) && <button onClick={stake} className="btn btn-primary me-2">Stake</button>
                }

                <button onClick={unstake} className="btn btn-primary me-2">Unstake</button>
                <button onClick={withdraw} className="btn btn-primary">Withdraw</button>
            </div>
        </div>
    </div>
}